import { useTheme } from "styled-components";
import { Text } from "../../../components/common/text/text";


interface EmptyStateProps {
    title: string;
    description: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    title,
    description
}) => {
    const theme = useTheme();
    return <>
        <Text as="h2" color={theme.colors.primaryBlue.main}>{title}</Text>
        <Text as="p" color={theme.colors.gray400.main}>{description}</Text>
    </>
}

export default EmptyState;
